import _ from 'underscore';
import { FileBase } from '../FileBase';
import { StringBase } from '../StringBase';

export class Geofence extends FileBase {
  custom = null;
  isValid() {
    return (this.custom && this.custom.length > 0) || super.isValid();
  }

  static count(target) {
    let len = 0;
    if (target && target.custom) {
      len = StringBase.count(target.custom);
    }
    if (target && target.uploaded && _.isObject(target.uploaded)) {
      len += 1;
    }
    return len;
  }
}
